<template>
  <div id="wholeArea">
    <div :style="contentsStyle">
      <div class="iframe-wrap-wrap" :class="publicPageData.layoutBorder ? 'iframe-wrap-wrap-border':''">
        <!--/* 
          forkstyle.comをiframe表示する場合はsandboxを付与しない（sandboxをつけるとoriginがnullになり、javascriptからcookieにアクセスできなくなる。もちろん、same-originは絶対付与してはいけないのでsandboxは使用できない）
        */-->
        <div class="iframe-parent" :style="iframeWrapStyle">
          <iframe
            style="position:absolute;top:1;left:1;border:none;box-sizing: content-box;transform-origin: 0 0;user-select: none;" :style="iframeStyle"
            :src="kiwiIframeURL"
            frameborder="1"
            scrolling="no"
            id="viewIframe"
            allow="autoplay;camera *;microphone *;geolocation;"
          />
          <Loading ref="loading" class="loading" :fadein="false" margin="10px" />
        </div>
      </div>
      <div v-if="!isCommentHistoryRight">
        <Description 
          :showDescription="showDescription"
          :publicPageData="publicPageData"
        />
      </div>
    </div>
    <!--/* コメント 履歴*/-->
    <div :style="commentHistoryWrapStyle">
      <CommentHistory 
        ref="commentHistory"
        :isPreview="isPreview"
        :isRightPosition="isCommentHistoryRight"
      />
    </div>
    
    <div v-if="isCommentHistoryRight">
      <Description 
        :showDescription="showDescription"
        :publicPageData="publicPageData"
      />
    </div>
    <div class="bottom-comment-input" :style="commentInputStyle">
      <textarea
        style="resize: vertical;"
        rows="1"
        class="form-control"
        name="content"
        v-model="commentInputText"
        type="text"
        :placeholder="$root.account.isLogin ? 'コメント欄は広げることができます' : 'コメントするにはログインしてください'"
        :maxlength="$root.const.commnentMaxLen"
        :disabled="!$root.account.isLogin"
        @keydown.stop="preventKeyEventToIframe"
        @keypress.stop="preventKeyEventToIframe"
        @keyup.stop="preventKeyEventToIframe"
      />
      <button class="btn btn-primary" style="margin-left:8px;overflow: hidden;font-size:smaller; padding:8px 2px;" @click="onComment" :disabled="!$root.account.isLogin || !commentInputText || isPreview">
        コメント
      </button>
    </div>
  </div>
</template>


<script lang="ts">
import { Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import CommentHistory from "@/pages/publicPage/_component/CommentHistory.vue";
import PublicPageResp from "@/interface/api/PublicPageResp";
import { RouteLocationNormalized } from 'vue-router';
import OnUrlChangeVue from '@/OnUrlChangeVue';
import {FMInitialized, FMSize, FMSetLayout} from '@/interface/kiwi/ForkstyleMessage';
import { Ref } from 'vue-property-decorator';
import Description from "@/pages/publicPage/_component/Description.vue";
import PublicPageStandardVue from '@/pages/publicPage/_interface/PublicPageStandardVue';
import CommentResp from '@/interface/api/CommentResp';
import Loading from "@/component/Loading.vue";


//HTMLのサイズを変更したら一緒に変更すること
const DIV_SPAN_X = 4 //iframeの親Divとコメント欄との間
const COMMENT_RIGHT_MIN_WIDTH = 250
const COMMENT_BOTTOM_MIN_HEIGHT = 60
const COMMENT_INPUT_HEIGHT = 54
const BORDER_LEN = 1


@Options({ 
  components: { CommentHistory, Description, Loading },
  props:{
    publicPageData:{
      type:Object
    },
    isPreview:{
      type:Boolean,
      default:false,
    },
    kiwiIframeURL:{
      type:String
    },
    publicPageTitle:{
      type:String
    },
    projectUserName:{
      type:String
    },
    viewLayoutRequest:{
      type:Object
    },
    commentOK:{
      type:Function
    },
  }
})
export default class extends OnUrlChangeVue implements PublicPageStandardVue  {
  // @ts-expect-error
  $root: RootVue;
  readonly publicPageData!: PublicPageResp;
  readonly isPreview!: boolean;
  readonly publicPageTitle!: string;
  readonly projectUserName!: string;
  readonly viewLayoutRequest!: null|FMSetLayout;
  readonly commentOK!: Function;
  readonly kiwiIframeURL!: string;

  //mounted前のlifesycleだと初期化されていないので使用できない点に注意
  @Ref() readonly commentHistory = null as any as CommentHistory;
  @Ref() readonly loading = null as any as Loading;
  


  showDescription = false
  commentInputText = "";

  //dom操作や検索は多少重いのでキャッシュしておく（10年前の発想）
  wholeArea: HTMLElement|null = null;
  isCommentHistoryRight = false
  iframeStyle = {} //width,heightはコンテンツの実値、transformに倍率を設定する
  iframeWrapStyle = {} // iframeWHStyleでの倍率込の値を設定する。iframeを拡大して表示すると、他の表示領域とかぶってしまうのでそれを防ぐ。
  contentsStyle = {}

  commentHistoryWrapStyle = {}
  commentInputStyle = {}

  get borderLen(){
    return this.publicPageData.layoutBorder ? BORDER_LEN * 2 : 0
  }

  resizeLayout(viewSize: FMSize){
    if(!this.wholeArea){
      this.wholeArea = document.getElementById('wholeArea');
    }
    
    if(!this.wholeArea){
      this.$nextTick(()=>{
        this.resizeLayout(viewSize)
      })
      return
    }
    
    const areaWidth = this.wholeArea.clientWidth;
    const MIN_IFRAME_WIDTH_WITH_RIGHT_COMMENT = 300;
    //縦幅がとれてない場合は右側コメント欄を表示しない
    this.isCommentHistoryRight = areaWidth > MIN_IFRAME_WIDTH_WITH_RIGHT_COMMENT + DIV_SPAN_X + COMMENT_RIGHT_MIN_WIDTH

    var windowHeight = this.$root.common.getWindowHeight();
    var headerHeight = this.$root.commonHeader.getHeaderHeight()
    this.setIframeStyles(viewSize, windowHeight, headerHeight)
    this.setStyles(viewSize,areaWidth, windowHeight, headerHeight)
  }

  hasAlreadyIframeSize(viewSize: FMSize){
    return viewSize.height === undefined 
  }

  setIframeStyles(viewSize: FMSize, windowHeight:number, headerHeight:number){
    this.iframeStyle = {
      'width': '100%', 
      'height': '100%', 
    }

    //コンテンツのサイズ通知が来る前の場合。
    if(this.hasAlreadyIframeSize(viewSize)){
      //iframeのサイズはコンテンツのサイズの通知が来てからレイアウトを決定する。
      //先にiframeのサイズを決定してしまうと、コンテンツのサイズを調べる時にiframeのサイズに影響を受けるため。    
      this.iframeWrapStyle = {
        'width':'initial',
        'height': 'initial',
        'border': 'none',
      }
    }else{
      var iframeHeight;
      if(this.isCommentHistoryRight){
        iframeHeight = Math.max(windowHeight - COMMENT_INPUT_HEIGHT - headerHeight - this.borderLen, viewSize.height);
      }else{
        iframeHeight = viewSize.height;
      }
      //box-sizing: border-boxなので、iframeに設定する値からborder幅を減らす
      iframeHeight -= this.borderLen;

      this.iframeWrapStyle = {
        'width':'100%',
        'height': iframeHeight + 'px',
        'border': (this.publicPageData.layoutBorder) ? '1px solid #999' : 'none',
      }
    }
  }
  
  setStyles(viewSize: FMSize,areaWidth:number, windowHeight:number, headerHeight:number){
    if(this.isCommentHistoryRight){
      const rightCommentWidth = this.getRightCommentWidth(areaWidth);
      //コメントの幅を設定。倍率の関係で残った横幅を設定する
      //固定幅レイアウトと違って、右側にコメントを表示する時は、ある程度Iframeのwidthが確保できるので
      //コメント履歴は縦幅を限界まで使う（固定レイアウトだと縦長コンテンツ＋右側コメントだとコメント入力欄のwidthが確保できない）
      this.setRightComment(
        areaWidth - DIV_SPAN_X - rightCommentWidth, 
        rightCommentWidth, 
        this.$root.common.getWindowHeight(),
        windowHeight - COMMENT_INPUT_HEIGHT - headerHeight - this.borderLen - this.borderLen,
      )
    }else{
      const COMMENT_HISTORY_MARGIN_TOP = 8
      //まだiframeが読み込まれていない場合      
      if(this.hasAlreadyIframeSize(viewSize)){
        this.setBottomComment(windowHeight - COMMENT_INPUT_HEIGHT - headerHeight - this.borderLen, 0)        
      }else{
        const commentHeight = Math.max(COMMENT_BOTTOM_MIN_HEIGHT, windowHeight - COMMENT_INPUT_HEIGHT - viewSize.height - headerHeight - this.borderLen - COMMENT_HISTORY_MARGIN_TOP)
        this.setBottomComment(commentHeight, COMMENT_HISTORY_MARGIN_TOP)
      }
    }
  }

  getRightCommentWidth(areaWidth:number){
    let ret = COMMENT_RIGHT_MIN_WIDTH
    if(areaWidth > 800){
      ret += (areaWidth - 800) * 0.3
    }
    if(areaWidth > 1000){
      ret += (areaWidth - 1000) * 0.1
    }
    if(areaWidth > 1200){
      ret += (areaWidth - 1200) * 0.1
    }
    return ret;
  }

  setRightComment(iframeWidth:number, commentHistoryWidth:number, commentHistoryHeight:number, iframeMinHeight:number){
    this.commentHistoryWrapStyle = {
      'width':commentHistoryWidth + 'px',
      'height': commentHistoryHeight + 'px',
      'position': 'fixed',
      'top': 0,
      //macのsafariだとleft省略で元DOMの位置基準ってのをしてくれないので指定する。rightだと画面リサイズでカクつくのでleft指定
      'left': ((this.$root.common.getWindowWidth() - this.wholeArea!.clientWidth) / 2 + iframeWidth + DIV_SPAN_X).toPrecision(4) + "px",

    }
    //入力欄は右側ではなく下側に表示するので、widthの設定値が異なる
    this.commentInputStyle = {
      'width':iframeWidth + 'px',
    }
    this.contentsStyle = {
      'display': 'inline-block',
      'vertical-align': 'top',
      'width':iframeWidth + 'px',
      'min-height': iframeMinHeight + 'px',
    }
  }
  setBottomComment(commentHeight:number, marginTop:number){
    this.commentHistoryWrapStyle = {
      'width':'100%',
      'height': commentHeight + 'px',
      'margin-top': marginTop + 'px',
      'margin-left': 'auto',
      'margin-right': 'auto',
      'display': 'block',
    }
    this.commentInputStyle = {
      'width':'initial',
    }
    this.contentsStyle = {
      'display': 'block',
    }
  }

  getHeaderRedText(){
    return this.showDescription ? "詳細を閉じる":"詳細を開く";
  }

  onHeaderClick(){
    this.showDescription = !this.showDescription
    this.$root.commonHeader.headerTitle.setTitleText(this.getHeaderRedText(), this.publicPageData.title)
  }

  init(){
    this.$root.commonHeader.headerTitle.setTitleText(this.getHeaderRedText(), this.publicPageData.title)
    this.resizeLayout({} as FMSize)
  }

  //継承元から呼び出される
  onUrlChanged(_newVal: RouteLocationNormalized, _oldVal: RouteLocationNormalized) {
    this.init()
  }

  onComment(){
    this.commentOK(this.commentInputText).then(()=>{
      this.commentInputText = ""
    })
  }
  
  public onViewNotFound(){
    this.loading.finish()
  }
  public onViewInitialized(_data: FMInitialized){
    this.loading.finish()
  }
  public clearIframeSize(){
    //画面サイズが変更された時にiframeに高さが指定されていると、iframe子側でも正確にスクロールサイズが計算されなくなる。
    //このためサイズをクリアした状態でサイズ送信を要求する。
    this.iframeStyle = {
      'width': '100%',
      'height': 'initial',
      'opacity': 0.2,
    };
  }
  
  public onViewSizeChanged(viewSize: FMSize){
    this.resizeLayout(viewSize)
  }

  public addComment(comment:CommentResp){
    if(this.commentHistory){
      this.commentHistory.addComment(comment)
    }else{
      //本番環境ではたぶん不要だけど、開発環境だとホットリロード時にthis.commentHistoryの参照が失われてエラーになる対策
      setTimeout(()=>{
        this.addComment(comment)
      }, 10)
    }
  }

  public getIframe():HTMLIFrameElement{
    return document.getElementById("viewIframe") as any;
  }

  created() {
    this.$root.commonHeader.headerTitle.addTitleClickListener(this.onHeaderClick)    

    this.init();
  }
  
  //ダミー関数。テキスト入力中はiframeにキーを流さない
  preventKeyEventToIframe(){}

  beforeUnmount(){
    this.$root.commonHeader.headerTitle.clearTitle()
  }
}
</script>

<style lang="scss" scoped>
#wholeArea{
  max-width:96%;
  margin-right: auto;
  margin-left: auto;
  
  /* inline-block間のスペース（font-sizeあり）がbuild時に取り除かれてしまうので、build前でもスペースのサイズを0にして同一レイアウト表示にする */
  font-size: 0;
  white-space: nowrap;
  > * {
    font-size: 1rem;
    white-space: initial;
  }

  @media (max-width: 768px) {
    max-width:98%;
  }
  @media (max-width: 576px) {
    max-width:100%;
  }
}

.visibility-hidden{
  visibility: hidden;
}
.bottom-comment-input {
  display: flex;
  align-items: start;
  margin-right: auto;
  /*marginにすると、背景色の変更箇所がおかしくなるため*/
  padding-top: 8px;
  padding-bottom: 8px;
}

.iframe-wrap-wrap{
  margin-left: auto;
  margin-right: auto;
  user-select: none;
}
.iframe-wrap-wrap-border{
  background-color: #000;
}

.iframe-parent{
  position:relative;
  //width:100%が基準になるのでcontent-boxにできない
  box-sizing: border-box;
  margin:auto;
  background-color: #fff;
  user-select:none;
}
.loading {
  position:absolute;
  top:3%;
  left:50%;
  transform:translateX(-50%);
}
</style>
